import React from "react";
import styles from "./Footer.module.css";
import facebook from "../../assets/icons/facebook.svg";
import tiktok from "../../assets/icons/tiktok.svg";
import instagram from "../../assets/icons/instagram.svg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <div className={styles.links}>
          <div className={styles.column}>
            <p>{t("footer.shortcuts")}</p>
            <div className={styles.shortcuts}>
              <Link to="/about" className={styles.link}>
                {t("footer.about")}
              </Link>
              <Link to="/musicians" className={styles.link}>
                {t("footer.musicians")}
              </Link>
              <Link to="/gallery" className={styles.link}>
                {t("footer.gallery")}
              </Link>
              <Link to="/contact" className={styles.link}>
                {t("footer.contact")}
              </Link>
              <Link to="/partners" className={styles.link}>
                {t("footer.partners")}
              </Link>
              <Link to="/tickets" className={styles.link}>
                {t("footer.tickets")}
              </Link>
            </div>
          </div>
          <div className={styles.column}>
            <p>{t("footer.fanpage")}</p>
            <div className={styles.social}>
              <a
                href="https://www.facebook.com/profile.php?id=61573040195940"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={facebook} alt="Facebook" />
              </a>
              <a
                href="https://www.instagram.com/yp_symphony_orchestra/"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={instagram} alt="Instagram" />
              </a>
              <a
                href="https://www.tiktok.com/@m..orkiestra.symf"
                aria-label="TikTok"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={tiktok} alt="TikTok" />
              </a>
            </div>
          </div>
        </div>
        <div className={styles.bottom}>
          <p aria-hidden="true">
            {t("footer.copyright", { year: currentYear })}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
